export default "__VITE_ASSET__IyPJz2Ee__"